export const downloadFile = (pdfBlob: Blob, name: string) => {
  const file = window.URL.createObjectURL(pdfBlob);
  const a = document.createElement('a');
  a.href = file;
  a.setAttribute('download', name + '.pdf');
  a.click();
};
